import { useCallback, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { BookingHotel } from "src/store/reducers/bookings";
import AddHotelBookingCanvas from "./AddHotelBookingCanvas";
import EditBookingHotelCanvas from "./EditBookingHotelCanvas";
import HotelEmailTemplateModal from "./HotelEmailTemplateModal";

interface ListBookingCabsProps {
  bookingId: string;
  bookingHotelData: BookingHotel[];
  setDeleteHotelId: React.Dispatch<React.SetStateAction<string | undefined>>;
}
function ListBookingHotels({
  bookingId,
  bookingHotelData,
  setDeleteHotelId,
}: ListBookingCabsProps) {
  const [editHotelId, setEditHotelId] = useState<number>();
  const [showHotelAddModal, setShowHotelAddModal] = useState(false);
  const [emailTemplateTarget, setEmailTemplateTarget] = useState<{
    bookingHotelId: string;
    hotelName: string;
  } | null>(null);
  const [show, setShow] = useState(bookingHotelData.length > 0);
  const toggleShow = useCallback(() => {
    setShow((show) => !show);
  }, []);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-xxl-12">
            <div className="card h-auto">
              <div className="card-header">
                <h4
                  className="heading mb-0 link"
                  role="button"
                  onClick={toggleShow}
                >
                  {show ? (
                    <span className="btn-icon-start">
                      <i className="fa fa-minus color-info"></i>
                    </span>
                  ) : (
                    <span className="btn-icon-start">
                      <i className="fa fa-plus color-info"></i>
                    </span>
                  )}
                  Hotels
                </h4>
                <Link
                  to={"#"}
                  className="btn btn-primary btn-sm"
                  data-bs-toggle="offcanvas"
                  onClick={() => setShowHotelAddModal(true)}
                >
                  + Add Hotel
                </Link>
              </div>
              <div className={!show ? "card-body d-none" : "card-body"}>
                {bookingHotelData.length > 0 ? (
                  <div className="table-responsive active-projects">
                    <div
                      id="projects-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="projects-tbl"
                        className="table table-hover dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Rooms</th>
                            <th>Price</th>
                            <th>Advance paid</th>
                            <th>Check in date</th>
                            <th>Check out date</th>
                            <th>Meal plan</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bookingHotelData?.map((hotelData, index) => (
                            <tr key={hotelData.id}>
                              <td>{hotelData.hotel?.name}</td>
                              <td>{hotelData.no_of_rooms}</td>
                              <td>{hotelData.hotel_price}</td>
                              <td>{hotelData.advance_amount_paid}</td>
                              <td>
                                {new Date(
                                  hotelData.checkin_date
                                ).toLocaleDateString('en-IN')}
                              </td>
                              <td>
                                {new Date(
                                  hotelData.checkout_date
                                ).toLocaleDateString('en-IN')}
                              </td>
                              <td>
                                {
                                  hotelData.meal_plan
                                }
                              </td>
                              {/* <td>{hotelData.}</td> */}
                              <td>
                                <NavLink
                                  className="btn btn-primary shadow btn-xs sharp me-1"
                                  onClick={() => setEditHotelId(index)}
                                  to={`#`}
                                  title="Edit"
                                >
                                  <i className={`fas fa-pen`} />
                                </NavLink>{" "}
                                <NavLink
                                  className="btn btn-info shadow btn-xs sharp me-1"
                                  onClick={() =>
                                    setEmailTemplateTarget({
                                      bookingHotelId: hotelData.id,
                                      hotelName: hotelData.hotel?.name ?? "",
                                    })
                                  }
                                  to={`#`}
                                  title="Email / WhatsApp Template"
                                >
                                  <i className="fas fa-envelope" />
                                </NavLink>{" "}
                                <NavLink
                                  className="btn btn-danger shadow btn-xs sharp"
                                  onClick={() => {
                                    setDeleteHotelId(hotelData.id);
                                  }}
                                  to={`#`}
                                  title="Delete"
                                >
                                  <i className={`fas fa-x`} />
                                </NavLink>{" "}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {/* <div className="d-sm-flex text-center justify-content-between align-items-center">
                  <PaginationText
                    currentPage={currentPage}
                    totalRecords={tableData.length}
                    perPage={sort}
                  />
                  <Pagination
                    currentPage={currentPage}
                    totalRecords={tableData.length}
                    perPage={sort}
                    changePage={setCurrentPage}
                  />
                </div> */}
                    </div>
                  </div>
                ) : (
                  <div className="d-flex align-items-center">
                    &nbsp;
                    <strong>Add hotels for this booking </strong>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddHotelBookingCanvas
        Title={"Add Hotel"}
        show={showHotelAddModal}
        bookingId={bookingId}
        setShow={setShowHotelAddModal}
      />
      <EditBookingHotelCanvas
        editId={
          typeof editHotelId !== "undefined"
            ? bookingHotelData?.[editHotelId]?.id
            : ""
        }
        Title={"Edit Hotel"}
        data={
          typeof editHotelId !== "undefined"
            ? bookingHotelData?.[editHotelId]
            : undefined
        }
        hide={() => setEditHotelId(undefined)}
      />
      <HotelEmailTemplateModal
        show={emailTemplateTarget !== null}
        onHide={() => setEmailTemplateTarget(null)}
        bookingId={bookingId}
        bookingHotelId={emailTemplateTarget?.bookingHotelId ?? ""}
        hotelName={emailTemplateTarget?.hotelName}
      />
    </>
  );
}

export default ListBookingHotels;
